import { render, staticRenderFns } from "./StaticDropdown.vue?vue&type=template&id=e66d8ab2&"
import script from "./StaticDropdown.vue?vue&type=script&lang=js&"
export * from "./StaticDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports